import { createModel } from "@/util/ModelUtil";

export default class SubscribeUserCheckModel {
  constructor(
    public userId: number = 0,
    public userName: string = "",
    public subscribeType: string = "",
    public expiredAt: string = ""
  ) {}

  public static create(list?: SubscribeUserCheck): SubscribeUserCheckModel {
    return createModel<SubscribeUserCheckModel>(SubscribeUserCheckModel, list);
  }
}
